// @ts-nocheck

// @ts-nocheck
import React, { CSSProperties, useEffect, useState, useRef } from "react";
import { createRoot } from "react-dom/client";
import {
  APIProvider,
  Map,
  Marker,
  AdvancedMarker,
  useMap,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

import "./MapInterface.css";
import { features } from "process";
import { Dumptruck } from "@deere/icons";
import ReactDOM from "react-dom";
import { Button } from "@deere/isg.component-library";
import { IconCircleClose } from "@deere/icons/new";
import CabControl from "../sidebar/panels/equipmentPanel/CabControl";

// Adding Drawing Manager Type for performance
interface DrawingManagerType extends google.maps.drawing.DrawingManager {}

// function MapVehicle() {
//     // This is a component for a vehicle that gets shown on the map
//     let [currentLatLong, setLatLong] = useState({ lat: 61.2176, lng: -149.8997 });
//     const mainMap = useMap('mainMap');
//     console.log(mainMap);

//     function runPan() {
//       // mainMap.center={ lat: 62.2176, lng: -148.8997 };
//       // mainMap.setCenter({ lat: 62.2176, lng: -148.8997 });
//       if (mainMap) {
//         mainMap.panTo({ lat: 62.2176, lng: -148.8997 });
//       }
//     }

//     return (
//       <>
//         <button className="devMapButton" onClick={runPan}>runPan</button>
//       </>
//     );
//   }

let drawingManagerIsRunning: boolean = false;
function GeoJSONDisplay({ gjson }: { gjson: JSON[] }) {
  const map = useMap("mainMap");
  const [geoJsonObj, setGeoJsonObj] = useState<JSON[]>();
  const [drawManage, setDrawManage] = useState<DrawingManagerType | null>(null);
  useEffect(() => {
    setGeoJsonObj(gjson);
  }, [gjson]);

  function initDrawingManager(): void {
    if (!drawingManagerIsRunning) {
      setTimeout(() => {
        const myDrawingManager = new google.maps.drawing.DrawingManager();
        setDrawManage(myDrawingManager);
        myDrawingManager.setMap(map);
        drawingManagerIsRunning = true;
        // You can add further logic to handle the DrawingManager here
      }, 1000); // waits for 1000 milliseconds or 1 second
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        initDrawingManager();
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [drawManage]);

  useEffect(() => {
    if (!map) return;
    if (geoJsonObj) {
      geoJsonObj.forEach((gjsonObj: any) => {
        // Expecting FeatureCollection
        if (gjsonObj.type === "FeatureCollection" && Array.isArray(gjsonObj.features)) {
          gjsonObj.features.forEach((feature: any) => {
            const featureId = feature.id || (feature.properties && feature.properties.id);
            if (!featureId) return; // skip if no id
            let existingFeature = map.data.getFeatureById(featureId);
            let geometry;
            if (feature.geometry.type === "Polygon") {
              geometry = new google.maps.Data.Polygon(
                feature.geometry.coordinates.map((ring: any) =>
                  ring.map((coord: any) => ({ lat: coord[1], lng: coord[0] })),
                ),
              );
            } else if (feature.geometry.type === "LineString") {
              geometry = new google.maps.Data.LineString(
                feature.geometry.coordinates.map((coord: any) => ({
                  lat: coord[1],
                  lng: coord[0],
                })),
              );
            } else if (feature.geometry.type === "Point") {
              geometry = new google.maps.Data.Point({
                lat: feature.geometry.coordinates[1],
                lng: feature.geometry.coordinates[0],
              });
            } else {
              // Unsupported geometry type
              return;
            }
            if (existingFeature) {
              // Update geometry and properties
              existingFeature.setGeometry(geometry);
              if (feature.properties) {
                Object.keys(feature.properties).forEach((key) => {
                  existingFeature.setProperty(key, feature.properties[key]);
                });
              }
            } else {
              // Add new feature
              const newFeature = new google.maps.Data.Feature({
                geometry,
                id: featureId,
                properties: feature.properties || {},
              });
              map.data.add(newFeature);
            }
          });
        }
      });
    }
    map.data.setStyle({
      fillColor: "lightblue",
      fillOpacity: 0.4,
      strokeColor: "blue",
      strokeOpacity: 1,
      strokeWeight: 2,
    });
  }, [map, geoJsonObj]);

  useEffect(() => {
    if (!map || !drawManage) return;
    // drawManage.setMap(map);
  }, [map]);

  return <></>;
}

// function MapInterface({ gjson, mapItemsList }: { gjson: any, mapItemsList: any}) {
//   // John Deere Dubuque Coordinates 42.56842877864018, -90.69038479038413
//   let [currentLatLong, setLatLong] = useState({ lat: 42.56842877864018, lng: -90.69038479038413 });
//   const mapRef = useRef(null);

//   // setLatLong({ lat: 61.2176, lng: -149.8997 });

//   function flyToWhiteHouse() {
//     setLatLong({ lat: 62.2176, lng: -148.8997 });
//     // console.log(Map.getCenter());
//   }

//   return (
//     <div className='MapInterface'>
//       <APIProvider apiKey={'AIzaSyBGE3dEEemmnwal41oxhnphiaoYy3s-P2c'} libraries={["drawing"]}>
//         <Map id={'mainMap'} mapId={'mainMap'} mapTypeId={'satellite'}
//           disableDefaultUI={true}
//           defaultCenter={currentLatLong}
//           // center={currentLatLong}
//           defaultZoom={15}
//         //onTilesLoaded={map => (mapRef.current = {state: {map}})}
//         >

//           <Marker position={currentLatLong} />

//           <AdvancedMarker
//             // className={"customMarker"}
//             position={{ lat: 61.2176, lng: -149.8997 }}>
//             <h2>I am so customized</h2>
//             <p>That is pretty awesome!</p>
//           </AdvancedMarker>

//           <GeoJSONDisplay gjson={gjson} />

//         </Map>

//         {/* <MapVehicle /> */}
//       </APIProvider>
//     </div>
//   );
// }

// setMapInstance={setMapInstance} mapInstance={mapInstance}

function MapObjectDisplay({
  mapInstance,
  setMapInstance,
  mapGeometryList,
  orgDataSession,
  mapEquipmentList,
  sessionName,
  selectedFeatureId,
  setSelectedFeatureId,
  missionPreviewActive,
  missionPreviewPaths,
  missionPreviewPoints,
  onFeatureClick,
  showCabControl,
}: {
  mapInstance: google.maps.Map | null;
  setMapInstance: (map: any) => void;
  sessionName: string;
  mapGeometryList: any;
  orgDataSession: any;
  mapEquipmentList: any;
  selectedFeatureId: string | null;
  setSelectedFeatureId: (id: string | null) => void;
  missionPreviewActive: boolean;
  missionPreviewPaths: any[];
  missionPreviewPoints: any[];
  onFeatureClick: (
    info: { name: string; type: string; latLng: { lat: number; lng: number } } | null,
  ) => void;
  showCabControl?: boolean;
}) {
  // Google Maps Data Layer setStyle must be re-set on every prop change, or it will close over stale values.

  const [isListening, setIsListening] = useState(false);
  const map = useMap("mainMap");
  // setMapInstance(map);
  // const map = mapInstance;
  const [refreshMapMapObjectsCount, setRefreshMapMapObjectsCount] = useState(0);

  // Ref so the click listener closure always has the current cab control state
  const cabControlRef = useRef(showCabControl || false);
  useEffect(() => {
    cabControlRef.current = showCabControl || false;
  }, [showCabControl]);

  // Hover tracking — refs only (no React state) to avoid re-render loops
  const hoveredFeatureIdRef = useRef<string | null>(null);
  const stylingFnRef = useRef<google.maps.Data.StylingFunction | null>(null);

  // Helper function to get style from element type
  const getStyleFromElementType = (elementType: string) => {
    if (elementType) {
      if (elementType == "NAVIGABLE_PATH" || elementType == "JOBSITE_PATH") {
        return {
          fillColor: "#87CEFA",
          strokeColor: "#87CEFA",
          strokeWeight: 4,
          zIndex: 10,
          clickable: true,
        };
      } else if (elementType == "VEHICLE_PATH") {
        return {
          fillColor: "#00008B",
          strokeColor: "#00008B",
          strokeWeight: 6,
          zIndex: 11,
          clickable: true,
        };
      } else if (elementType == "WINDROW") {
        return {
          fillColor: "#7700c7",
          strokeColor: "#7700c7",
          strokeWeight: 4,
          zIndex: 10,
          clickable: true,
        };
      } else if (elementType == "STATIC_ROUTE") {
        return {
          fillColor: "#00FFC3",
          strokeColor: "#00FFC3",
          strokeWeight: 4,
          zIndex: 10,
          clickable: true,
        };
      } else if (elementType == "RESTRICTED_ZONE") {
        return { fillColor: "#e42929", strokeColor: "#8b1717", zIndex: 9, clickable: true };
      } else if (elementType == "FREE_SPACE_ZONE") {
        return { fillColor: "#33bd3d", strokeColor: "#1c6521", zIndex: 9, clickable: true };
      } else if (elementType == "BOUNDARY") {
        return {
          fillColor: "rgba(255, 0, 255, 0.0)",
          strokeColor: "rgb(255, 0, 255)",
          zIndex: 9,
          clickable: true,
        };
      } else if (elementType == "OI_OBJECT") {
        return {
          fillColor: "rgba(0, 4, 255, 0.3)",
          strokeColor: "rgb(0, 4, 255)",
          zIndex: 9,
          clickable: true,
        };
      } else if (elementType == "WORK_ZONE") {
        return {
          fillColor: "rgba(255, 136, 0, 0.3)",
          strokeColor: "rgb(255, 136, 0)",
          zIndex: 9,
          clickable: true,
        };
      }
    }
    // Default style — visible gray so unrecognized types are not invisible
    return {
      fillColor: "#999999",
      fillOpacity: 0.4,
      strokeColor: "#999999",
      strokeOpacity: 1,
      strokeWeight: 2,
      clickable: true,
    };
  };

  // useEffect(() => {
  //   // if(map){
  //   //   // If mapEquipmentList is updated, clear the map (This will remove shapes and lines when the org is updated)
  //   //   map.data.forEach((thisFeature) => {
  //   //     map.data.remove(thisFeature);
  //   //   })
  //   // }
  // }, [mapEquipmentList]);

  const testingGeoJSON = {
    features: [
      {
        geometry: {
          coordinates: [
            [
              [-90.7167508044, 42.5831218419],
              [-90.716929257, 42.5831153208],
              [-90.7169633035, 42.583118145],
              [-90.7169959976, 42.5831279453],
              [-90.7170176509, 42.5831408125],
              [-90.7170373113, 42.5831594867],
              [-90.7170502685, 42.5831778646],
              [-90.7170682905, 42.5832214821],
              [-90.7170793301, 42.5832608082],
              [-90.7170891761, 42.5833288524],
              [-90.7171103945, 42.5836744452],
              [-90.7171078728, 42.5838084645],
              [-90.7166801598, 42.583787732],
              [-90.7166848886, 42.5837117721],
              [-90.7166841068, 42.5836247238],
              [-90.7166794048, 42.5835462788],
              [-90.7166709271, 42.5834754962],
              [-90.7166188773, 42.5832161834],
              [-90.7166041687, 42.5831693209],
              [-90.7165855826, 42.5831369382],
              [-90.7165660242, 42.5831159193],
              [-90.716541709, 42.5831002308],
              [-90.7164178941, 42.5830568947],
              [-90.7163456721, 42.5830209213],
              [-90.7162867378, 42.5829756867],
              [-90.7162238363, 42.5829120588],
              [-90.7160666505, 42.5827309109],
              [-90.7157100546, 42.5823335228],
              [-90.7150278307, 42.5815383392],
              [-90.7144875093, 42.5809145724],
              [-90.7143914813, 42.5808077134],
              [-90.7143430465, 42.5807582819],
              [-90.7142896801, 42.5807100418],
              [-90.7142442552, 42.5806761804],
              [-90.7142297506, 42.5806708982],
              [-90.7142146241, 42.5806720139],
              [-90.7141995888, 42.58067895],
              [-90.7141754288, 42.5806983535],
              [-90.7141558279, 42.5807057775],
              [-90.7139867954, 42.5807516955],
              [-90.7138299817, 42.5808034257],
              [-90.7135381282, 42.5809091059],
              [-90.7132955358, 42.5810093677],
              [-90.7131828946, 42.58104853],
              [-90.7130631351, 42.5810783066],
              [-90.7129232604, 42.5811008186],
              [-90.7128494179, 42.5811071975],
              [-90.712723321, 42.5811087462],
              [-90.7126664094, 42.5810989984],
              [-90.7126427234, 42.5810878078],
              [-90.7126266957, 42.5810752633],
              [-90.7126055319, 42.5810483632],
              [-90.712574256, 42.5809787476],
              [-90.7125369747, 42.5809270273],
              [-90.7124910355, 42.5808801628],
              [-90.7124009056, 42.5808052794],
              [-90.7123527762, 42.5807792086],
              [-90.7122548906, 42.5807415197],
              [-90.712216209, 42.5807189592],
              [-90.712187983, 42.5806952786],
              [-90.7121671057, 42.5806655323],
              [-90.7121570581, 42.5806317997],
              [-90.7121581909, 42.5806107742],
              [-90.7121682232, 42.5805837052],
              [-90.7121821021, 42.5805659015],
              [-90.7122076555, 42.5805463997],
              [-90.7122392688, 42.5805336022],
              [-90.7122727002, 42.5805277757],
              [-90.7123126446, 42.5805293276],
              [-90.712357007, 42.5805405383],
              [-90.7126294952, 42.5806639176],
              [-90.7126504654, 42.5806678223],
              [-90.7126786988, 42.5806673971],
              [-90.7127674646, 42.5806477347],
              [-90.7128138489, 42.5806433424],
              [-90.712856633, 42.5806478909],
              [-90.7129061988, 42.5806627221],
              [-90.7129192505, 42.5806693029],
              [-90.7129418352, 42.5806883778],
              [-90.7129616758, 42.5807172624],
              [-90.7129728246, 42.5807512224],
              [-90.7129901567, 42.5808452447],
              [-90.7130063893, 42.5808837968],
              [-90.7130226435, 42.5809101402],
              [-90.7130479252, 42.580937172],
              [-90.7130836772, 42.580961918],
              [-90.7131206934, 42.5809774507],
              [-90.7131604706, 42.5809842591],
              [-90.7131959299, 42.5809813137],
              [-90.7132309102, 42.5809718123],
              [-90.7133081848, 42.5809398295],
              [-90.713540622, 42.5808533466],
              [-90.7137997412, 42.5807608885],
              [-90.7142150572, 42.5806265561],
              [-90.714266775, 42.5806136714],
              [-90.7143086878, 42.5806103348],
              [-90.7143584364, 42.580619146],
              [-90.7143969696, 42.5806366865],
              [-90.7144363665, 42.5806707465],
              [-90.7145144793, 42.5807751049],
              [-90.7146495932, 42.5809398317],
              [-90.7159809673, 42.5824931151],
              [-90.7162525553, 42.5827987388],
              [-90.7163261119, 42.5828715072],
              [-90.7163782534, 42.5829141691],
              [-90.7164327263, 42.5829481925],
              [-90.7165021381, 42.5829781758],
              [-90.7165704181, 42.582996284],
              [-90.7166368947, 42.5830050833],
              [-90.7166971908, 42.5830075732],
              [-90.7167934358, 42.5830049653],
              [-90.7172392869, 42.5829770927],
              [-90.7173346063, 42.582978338],
              [-90.7174272963, 42.5829871679],
              [-90.7175409712, 42.583010919],
              [-90.717618398, 42.5830372844],
              [-90.7177009683, 42.5830766883],
              [-90.717762578, 42.5831202283],
              [-90.7177969431, 42.5831550945],
              [-90.7178314764, 42.5832021608],
              [-90.7178567923, 42.5832524581],
              [-90.7178743505, 42.5833077157],
              [-90.7178826666, 42.5833555541],
              [-90.7178893575, 42.5834459168],
              [-90.7178884522, 42.5837051852],
              [-90.7178943071, 42.5837370079],
              [-90.7179145497, 42.5837777493],
              [-90.7179415932, 42.5838082542],
              [-90.7180667407, 42.5839134365],
              [-90.7182411803, 42.5840763416],
              [-90.7184213107, 42.5842350826],
              [-90.7185166219, 42.5843093544],
              [-90.7186083696, 42.5843741785],
              [-90.7186322389, 42.5843861758],
              [-90.7186703565, 42.5843962208],
              [-90.7188518496, 42.5844085854],
              [-90.718937902, 42.5844213967],
              [-90.7189705759, 42.584431524],
              [-90.718993735, 42.5844424513],
              [-90.7190270162, 42.584467154],
              [-90.7190507401, 42.5844985659],
              [-90.7190627103, 42.5845341543],
              [-90.7190656568, 42.5845694679],
              [-90.7190616756, 42.5846238853],
              [-90.7190613457, 42.5847488575],
              [-90.719057855, 42.5847810026],
              [-90.7190505354, 42.5848004172],
              [-90.7190313741, 42.5848257072],
              [-90.7190111931, 42.5848415923],
              [-90.7189839055, 42.5848557098],
              [-90.7189320231, 42.5848702914],
              [-90.7188721686, 42.5848731759],
              [-90.7187582029, 42.5848644321],
              [-90.7186695005, 42.584861251],
              [-90.7185884993, 42.5848632741],
              [-90.7185324487, 42.584868574],
              [-90.7184099705, 42.5848899858],
              [-90.718077412, 42.5849730322],
              [-90.7179562605, 42.584991606],
              [-90.7179191683, 42.584989884],
              [-90.7178873025, 42.5849836122],
              [-90.7178630463, 42.5849740705],
              [-90.717844677, 42.5849620364],
              [-90.7178277107, 42.5849466159],
              [-90.7178137048, 42.5849269154],
              [-90.7178042849, 42.5849030349],
              [-90.7178020481, 42.5848853837],
              [-90.7178087795, 42.584752977],
              [-90.7178004819, 42.5839384502],
              [-90.7178002497, 42.5836659613],
              [-90.7178042556, 42.583391333],
              [-90.7178015925, 42.5833447164],
              [-90.7177948173, 42.5833003602],
              [-90.717782286, 42.5832588284],
              [-90.7177637001, 42.5832210512],
              [-90.7177393616, 42.5831870296],
              [-90.7177078411, 42.5831564538],
              [-90.7176693381, 42.5831291163],
              [-90.7176243428, 42.5831046327],
              [-90.7175724009, 42.5830842304],
              [-90.7175146121, 42.5830674281],
              [-90.7173833684, 42.5830448979],
              [-90.71729854, 42.5830394006],
              [-90.7172163383, 42.5830411415],
              [-90.7167468624, 42.5830800994],
              [-90.716728662, 42.583085116],
              [-90.7167058237, 42.5830966343],
              [-90.7166928195, 42.5831069455],
              [-90.7166814455, 42.5831220343],
              [-90.716679714, 42.5831413041],
              [-90.7166844542, 42.5831526994],
              [-90.7166933014, 42.5831628817],
              [-90.7167042714, 42.5831685968],
              [-90.7167371699, 42.5831731899],
              [-90.7167588599, 42.5831687763],
              [-90.7167804671, 42.5831575264],
              [-90.7167508044, 42.5831218419],
            ],
          ],
          type: "Polygon",
        },
        id: 0,
        properties: {
          boundarytype: "Exterior",
          isactive: true,
          ispassable: true,
          name: "Demo Area-Boundary",
          offsetid: null,
          parent: null,
          signaltype: 6218,
        },
        type: "Feature",
      },
    ],
    type: "FeatureCollection",
  };

  interface Location {
    longitude: number;
    latitude: number;
  }

  interface Point {
    location: Location;
  }

  interface PointsList {
    points: Point[];
    zoneType: string;
  }

  function getGeoJsonFromPoints(gjson: PointsList, shapeType: string, featureID: string) {
    // Extract coordinates from the points
    const coordinates = gjson.points.map((point) => [
      point.location.longitude,
      point.location.latitude,
    ]);
    let lastPointLocation = Object.values(gjson.points)[0].location;
    coordinates.push([lastPointLocation.longitude, lastPointLocation.latitude]);

    // Determine the GeoJSON type based on the zoneType
    let geoJson: any;

    if (shapeType === "polygon") {
      // For polygons, coordinates should be wrapped in an array
      geoJson = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [coordinates], // Coordinates array must be wrapped in another array
        },
        properties: {
          id: featureID,
          name: gjson.zoneType,
        },
      };
    } else if (shapeType === "line") {
      geoJson = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: coordinates,
        },
        properties: {
          id: featureID,
          name: gjson.zoneType,
        },
      };
    } else {
      // Handle other zone types or throw an error
      throw new Error(`Unsupported zone type: ${gjson.zoneType}`);
    }

    return geoJson;
  }

  // Adding all the shapes data to the map
  // map.data.addGeoJson(gjsonObj);
  // useEffect(() => {
  //   // Get all of the lines, shapes, and draw them on the map
  //   if (map) {
  //     // If mapEquipmentList is updated, clear the map (This will remove shapes and lines when the org is updated)
  //     // map.data.forEach((thisFeature) => {
  //     //   map.data.remove(thisFeature);
  //     // })

  //     if (orgDataSession !== undefined && "Shape" in orgDataSession) {

  //       function getOrderedShapes(shapes: any): any {
  //         // Function to compute the area of a shape using the Shoelace formula
  //         function computeArea(points: any[]): number {
  //           let area = 0;
  //           const n = points.length;

  //           for (let i = 0; i < n; i++) {
  //             const j = (i + 1) % n; // Wrap around to the first point
  //             area += points[i].location.longitude * points[j].location.latitude;
  //             area -= points[j].location.longitude * points[i].location.latitude;
  //           }
  //           area = Math.abs(area) / 2;
  //           return area;
  //         }

  //         // Create an array to hold shapes with their computed areas
  //         const shapesWithAreas = Object.entries(shapes).map(([shapeIndex, shape]) => {
  //           const area = computeArea((shape as any).points);
  //           return { shapeIndex, area, shape };
  //         });

  //         // Sort the shapes by area in descending order
  //         shapesWithAreas.sort((a, b) => b.area - a.area);

  //         // Peter did this
  //         return shapesWithAreas;

  //         // Create a new ordered shapes object
  //         const orderedShapes: any = {};
  //         shapesWithAreas.forEach(({ shapeIndex, shape }) => {
  //           orderedShapes[shapeIndex] = shape;
  //         });

  //         return orderedShapes;
  //       }

  //       let orderedShapes = getOrderedShapes(orgDataSession.Shape);

  //       // for (const shapeIndex in orderedShapes) {
  //       orderedShapes.forEach(({ shapeIndex, shape }: { shapeIndex: any, shape: any }) => {
  //         let thisShape = shape;

  //         // Setting the drawing colors for the map
  //         map.data.setStyle({
  //           fillColor: '#ffffff',
  //           fillOpacity: 0.4,
  //           strokeColor: '#ffffff',
  //           strokeOpacity: 1,
  //           strokeWeight: 2
  //         }); // This is the standard colors

  //         map.data.setStyle(function (thisFeature) {
  //           let zoneType = thisFeature.getProperty("zoneType")
  //           if (zoneType) {
  //             if (zoneType == "RESTRICTED_ZONE") {
  //               // console.log("This is a RESTRICTED_ZONE");
  //               return {
  //                 fillColor: '#e42929',
  //                 strokeColor: '#8b1717'
  //               }
  //             } else if (zoneType == "FREE_SPACE_ZONE") {
  //               // console.log("This is a FREE_SPACE_ZONE");
  //               return {
  //                 fillColor: '#33bd3d',
  //                 strokeColor: '#1c6521'
  //               }
  //             }
  //           }

  //           return {
  //             fillColor: '#ffffff',
  //             fillOpacity: 0.4,
  //             strokeColor: '#ffffff',
  //             strokeOpacity: 1,
  //             strokeWeight: 2
  //           }
  //         } as google.maps.Data.StylingFunction);

  //         function addFeatureToMap(shape: any, map: google.maps.Map) {
  //           let myPolygon = new google.maps.Data.Polygon(getPolyFromPoints(shape.points));
  //           let myFeatureOptions: google.maps.Data.FeatureOptions = {
  //             geometry: myPolygon,
  //             id: shapeIndex,
  //             properties: {
  //               zoneType: shape.zoneType,
  //             },
  //           }
  //           let myNewFeature = new google.maps.Data.Feature(myFeatureOptions);
  //           map.data.add(myNewFeature);
  //         }

  //         function updateFeatureToMap(shape: any, feature: any, map: google.maps.Map) {
  //           feature.setGeometry(new google.maps.Data.Polygon(getPolyFromPoints(shape.points)));
  //         }

  //         function getPolyFromPoints(shapePoints: any): google.maps.LatLng[][] {
  //           let pointsList = [];
  //           for (const shapePointIndex in shapePoints) {
  //             let thisPoint = shapePoints[shapePointIndex];
  //             pointsList.push(new google.maps.LatLng(
  //               thisPoint.location.latitude,
  //               thisPoint.location.longitude
  //             ));
  //           }
  //           return [pointsList];
  //         }

  //         // Check if the shapeIndex as an id exists
  //         let feature = map.data.getFeatureById(shapeIndex as string);
  //         if (feature) {
  //           // The feature currently exists, update it

  //           // feature.forEachProperty((propertyValue, propertyName) => {
  //           //   console.log(propertyName + ": " + propertyValue);
  //           // });
  //           updateFeatureToMap(thisShape, feature, map);
  //         } else {
  //           // The feature does not exist, create it
  //           addFeatureToMap(thisShape, map);
  //         }

  //       });
  //     }

  //     // checking if the clickListener is set up
  //     if (!isListening) {
  //       map.data.addListener("click", (mouseEvent: google.maps.Data.MouseEvent) => {
  //         // console.log(mouseEvent);
  //         console.log(mouseEvent.feature.getId());
  //         mouseEvent.feature.forEachProperty((propertyValue, propertyName) => {
  //           console.log(propertyName + ": " + propertyValue);
  //         });
  //       })
  //       map.addListener("click", (mouseEvent: google.maps.MapMouseEvent) => {
  //         console.log("Lat: " + mouseEvent.latLng?.lat() + " Lng: " + mouseEvent.latLng?.lng());
  //       })
  //       setIsListening(true);
  //     }
  //   }
  // }, [orgDataSession]);

  // handles updateds to the mapGeometryList
  useEffect(() => {
    if (map) {
      // List for all the features currently on the map. All items still on this list get removed
      let mapFeaturesList: Array<any> = [];
      map.data.forEach((thisFeature) => {
        // Ensuring the feature is not part of a protected class
        if (
          thisFeature.getId() !== "temporaryBoundaryID" ||
          !thisFeature.getId()?.toString().includes("uploadedGeoJSON")
        ) {
          mapFeaturesList.push(thisFeature.getId());
        }
      });

      // Handeling all of the Shapes
      if (Object.keys(mapGeometryList.Shapes).length > 0) {
        // Gets an orderd list of largest to smallest area from mapGeometryList
        function getOrderedShapes(shapes: any): any {
          // Function to compute the area of a shape using the Shoelace formula
          function computeArea(points: any[]): number {
            if (!points || points.length === 0) return 0;
            let area = 0;
            const n = points.length;

            for (let i = 0; i < n; i++) {
              const j = (i + 1) % n; // Wrap around to the first point
              area += points[i].location.longitude * points[j].location.latitude;
              area -= points[j].location.longitude * points[i].location.latitude;
            }
            area = Math.abs(area) / 2;
            return area;
          }

          // Create an array to hold shapes with their computed areas
          const shapesWithAreas = shapes
            ? Object.entries(shapes).map(([shapeIndex, shape]) => {
                const area = computeArea((shape as any).points);
                return { shapeIndex, area, shape };
              })
            : [];

          // Sort the shapes by area in descending order
          shapesWithAreas.sort((a, b) => b.area - a.area);

          // Peter did this
          return shapesWithAreas;
        }

        getOrderedShapes(mapGeometryList.Shapes[0]).forEach((thisOrderedObject: any) => {
          let thisShape: any = thisOrderedObject.shape;
          let thisShapeIndex: any = thisOrderedObject.shapeIndex;
          // Use uuid if present, otherwise fallback to index
          const attributeId = thisShape.uuid || thisShapeIndex;
          function addFeatureToMap(shape: any, map: google.maps.Map) {
            let myPolygon = new google.maps.Data.Polygon(getPolyFromPoints(shape.points));
            let myFeatureOptions: google.maps.Data.FeatureOptions = {
              geometry: myPolygon,
              id: attributeId,
              properties: {
                zoneType: shape.zoneType,
                featureName: thisShapeIndex,
                featureType: shape.zoneType,
              },
            };
            let myNewFeature = new google.maps.Data.Feature(myFeatureOptions);
            map.data.add(myNewFeature);
          }

          function updateFeatureToMap(shape: any, feature: any, map: google.maps.Map) {
            feature.setGeometry(new google.maps.Data.Polygon(getPolyFromPoints(shape.points)));
            // Check if the zone type is the same
            let zoneType: string = (feature.getProperty("zoneType") as any)?.toString();
            if (zoneType !== shape.zoneType) {
              feature.setProperty("zoneType", shape.zoneType);
            }
          }

          function getPolyFromPoints(shapePoints: any): google.maps.LatLng[][] {
            let pointsList = [];
            for (const shapePointIndex in shapePoints) {
              let thisPoint = shapePoints[shapePointIndex];
              pointsList.push(
                new google.maps.LatLng(thisPoint.location.latitude, thisPoint.location.longitude),
              );
            }
            return [pointsList];
          }

          // Check if the shapeIndex as an id exists
          let feature: google.maps.Data.Feature | undefined = map.data.getFeatureById(attributeId);
          if (feature) {
            // The feature currently exists, update it

            // feature.forEachProperty((propertyValue, propertyName) => {
            //   console.log(propertyName + ": " + propertyValue);
            // });
            updateFeatureToMap(thisShape, feature, map);
            let indexToRemove = mapFeaturesList.indexOf(attributeId);
            if (indexToRemove !== -1) {
              (mapFeaturesList as any[]).splice(indexToRemove, 1);
            }
          } else {
            // The feature does not exist, create it
            addFeatureToMap(thisShape, map);
          }
        });
      }

      // Handeling all of the Lines
      if (Object.keys(mapGeometryList.Lines).length > 0) {
        Object.entries(mapGeometryList.Lines[0]).forEach(
          ([thisLineKey, thisLine]: [string, any]) => {
            // Use uuid if present, otherwise fallback to index
            const attributeId = thisLine.uuid || thisLineKey;
            function addFeatureToMap(line: any, map: google.maps.Map) {
              let myLine = new google.maps.Data.LineString(getPolyFromPoints(line.points)[0]);
              let myFeatureOptions: google.maps.Data.FeatureOptions = {
                geometry: myLine,
                id: attributeId,
                properties: {
                  pathType: line.pathType,
                  featureName: thisLineKey,
                  featureType: line.pathType,
                },
              };
              let myNewFeature = new google.maps.Data.Feature(myFeatureOptions);
              map.data.add(myNewFeature);
            }

            function updateFeatureToMap(line: any, feature: any, map: google.maps.Map) {
              // console.log(feature);
              // console.log(line.points);

              feature.setGeometry(
                new google.maps.Data.LineString(getPolyFromPoints(line.points)[0]),
              );
              // Check if the zone type is the same
              let pathType: string = (feature?.getProperty("pathType") as any)?.toString() || "";
              let myLine = new google.maps.Data.LineString(getPolyFromPoints(line.points)[0]);
              if (pathType !== line.pathType) {
                const thisPathType = line.pathType;
                feature.setProperty("pathType", thisPathType);
              }
              // console.log("line.pathType: ", line.pathType);
              // console.log("myLine: ", myLine);
              // console.log("feature: ", feature);
              feature.setProperty("pathType", line.pathType);
              feature.setGeometry(myLine);
              // map.data.toGeoJson((a: object) => {
              //   console.log(a);
              // });
            }

            function getPolyFromPoints(shapePoints: any): google.maps.LatLng[][] {
              let pointsList = [];
              for (const shapePointIndex in shapePoints) {
                let thisPoint = shapePoints[shapePointIndex];
                pointsList.push(
                  new google.maps.LatLng(
                    thisPoint?.location?.latitude,
                    thisPoint?.location?.longitude,
                  ),
                );
              }
              return [pointsList];
            }

            // Check if the shapeIndex as an id exists
            let feature = map.data.getFeatureById(attributeId);
            if (feature) {
              // The feature currently exists, update it

              // feature.forEachProperty((propertyValue, propertyName) => {
              //   console.log(propertyName + ": " + propertyValue);
              // });
              // console.log(feature.getId());
              updateFeatureToMap(thisLine, feature, map);
              // let indexToRemove = mapFeaturesList.indexOf(thisLineIndex);
              let indexToRemove = mapFeaturesList.indexOf(feature.getId());
              if (indexToRemove !== -1) {
                (mapFeaturesList as any[]).splice(indexToRemove, 1);
              }
            } else {
              // console.log("Adding the Feature");
              // The feature does not exist, create it
              addFeatureToMap(thisLine, map);
            }
          },
        );
      }

      function getStyleFromElementType(elementType: string) {
        // console.log("getStyleFromElementType: elementType :", elementType);
        // console.log("elementType == STATIC_ROUTE", (elementType == "STATIC_ROUTE"));
        if (elementType) {
          if (elementType == "NAVIGABLE_PATH" || elementType == "JOBSITE_PATH") {
            return {
              fillColor: "#87CEFA", // Light Blue
              strokeColor: "#87CEFA",
              strokeWeight: 4,
              zIndex: 10,
              clickable: true,
            };
          } else if (elementType == "VEHICLE_PATH") {
            return {
              fillColor: "#00008B", // Dark Blue
              strokeColor: "#00008B",
              strokeWeight: 6,
              zIndex: 11, // Higher z-index to show on top
              clickable: true,
            };
          } else if (elementType == "WINDROW") {
            return {
              fillColor: "#7700c7",
              strokeColor: "#7700c7",
              strokeWeight: 4,
              zIndex: 10,
              clickable: true,
            };
          } else if (elementType == "STATIC_ROUTE") {
            return {
              fillColor: "#00FFC3",
              strokeColor: "#00FFC3",
              strokeWeight: 4,
              zIndex: 10,
              clickable: true,
            };
          } else if (elementType == "RESTRICTED_ZONE") {
            return {
              fillColor: "#e42929",
              strokeColor: "#8b1717",
              zIndex: 9,
              clickable: true,
            };
          } else if (elementType == "FREE_SPACE_ZONE") {
            return {
              fillColor: "#33bd3d",
              strokeColor: "#1c6521",
              zIndex: 9,
              clickable: true,
            };
          } else if (elementType == "BOUNDARY") {
            return {
              fillColor: "rgba(255, 0, 255, 0.0)",
              strokeColor: "rgb(255, 0, 255)",
              zIndex: 9,
              clickable: true,
            };
          } else if (elementType == "OI_OBJECT") {
            return {
              fillColor: "rgba(0, 4, 255, 0.3)",
              strokeColor: "rgb(0, 4, 255)",
              zIndex: 9,
              clickable: true,
            };
          } else if (elementType == "WORK_ZONE") {
            return {
              fillColor: "rgba(255, 136, 0, 0.3)",
              strokeColor: "rgb(255, 136, 0)",
              zIndex: 9,
              clickable: true,
            };
          }
        }
        // Default style — visible gray so unrecognized types are not invisible
        return {
          fillColor: "#999999",
          fillOpacity: 0.4,
          strokeColor: "#999999",
          strokeOpacity: 1,
          strokeWeight: 2,
          clickable: true,
        };
      }

      // Setting the styling for all the features
      const stylingFn = function (thisFeature) {
        if (thisFeature && thisFeature.getId) {
          const attributeId = thisFeature.getId();
        }
        let pathType = thisFeature.getProperty("pathType");
        let zoneType = thisFeature.getProperty("zoneType");

        // Get base style
        const baseStyle = getStyleFromElementType(String(pathType ?? zoneType ?? ""));

        // Check if this feature is part of the mission preview
        const featureId = String(thisFeature.getId() || "").replace(/[{}]/g, "");
        const isPartOfMission =
          missionPreviewActive &&
          missionPreviewPaths.some((pathData: any) => {
            // Extract UUID from path data object
            const pathUuid = String(pathData.uuid || pathData || "").replace(/[{}]/g, "");
            return featureId === pathUuid;
          });

        if (
          selectedFeatureId &&
          thisFeature.getId &&
          String(thisFeature.getId()).replace(/[{}]/g, "") ===
            String(selectedFeatureId).replace(/[{}]/g, "")
        ) {
          // Normal mode: green highlight
          return {
            fillColor: "#289730",
            fillOpacity: 0.6,
            strokeColor: "#1C6521",
            strokeOpacity: 1,
            strokeWeight: 4,
            zIndex: 100,
          };
        }

        // Preview mode styling
        if (missionPreviewActive) {
          if (isPartOfMission) {
            // Highlight mission paths with subtle grey outline
            return {
              ...baseStyle,
              strokeColor: "#888888",
              strokeOpacity: 0.6,
              strokeWeight: 3,
              fillOpacity: 0,
              zIndex: 50,
            };
          } else {
            // Fade non-mission elements with grey strokes
            return {
              ...baseStyle,
              strokeColor: "#999999",
              fillOpacity: (baseStyle.fillOpacity || 0.6) * 0.1,
              strokeOpacity: 0.2,
              zIndex: 1,
            };
          }
        }

        // Dim non-selected features when a feature is selected outside preview
        if (selectedFeatureId && !missionPreviewActive) {
          return {
            ...baseStyle,
            fillOpacity: (baseStyle.fillOpacity || 0.6) * 0.3,
            strokeOpacity: (baseStyle.strokeOpacity || 1) * 0.3,
            zIndex: 1,
          };
        }

        return baseStyle;
      } as google.maps.Data.StylingFunction;
      stylingFnRef.current = stylingFn;
      map.data.setStyle(stylingFn);

      // Removing all of the features not found
      if (mapFeaturesList.length > 0) {
        mapFeaturesList.forEach((thisFeature: any) => {
          const featureToRemove = map.data.getFeatureById(thisFeature);
          if (featureToRemove) {
            map.data.remove(featureToRemove);
          }
        });
      }

      // console.log(map.data);

      // checking if the clickListener is set up
      if (!isListening) {
        map.data.addListener("click", (mouseEvent: google.maps.Data.MouseEvent) => {
          if (cabControlRef.current) return; // Ignore feature clicks in cab control
          const feature = mouseEvent.feature;
          const uuid = feature.getId();
          if (uuid !== undefined && setSelectedFeatureId) setSelectedFeatureId(String(uuid));
          const name = (feature.getProperty("featureName") as string) || "Unknown";
          const type = (feature.getProperty("featureType") as string) || "Unknown";
          const latLng = mouseEvent.latLng;
          if (latLng) {
            onFeatureClick({ name, type, latLng: { lat: latLng.lat(), lng: latLng.lng() } });
          }
        });

        map.addListener("click", () => {
          if (setSelectedFeatureId) setSelectedFeatureId(null);
          onFeatureClick(null);
        });

        // Hover listeners (used to support Go To mode highlights; now only tracks id)
        map.data.addListener("mouseover", (e: google.maps.Data.MouseEvent) => {
          const id = e.feature.getId();
          if (id !== undefined) {
            hoveredFeatureIdRef.current = String(id);
          }
        });
        map.data.addListener("mouseout", () => {
          hoveredFeatureIdRef.current = null;
        });

        setIsListening(true);
      }
    }
  }, [mapGeometryList, selectedFeatureId, missionPreviewActive, missionPreviewPaths]);

  // Force map style update when preview state changes
  useEffect(() => {
    if (map && map.data) {
      // Extract UUIDs from mission path data for comparison
      const missionPathUuids = missionPreviewPaths.map((pathData: any) =>
        String(pathData.uuid || "").replace(/[{}]/g, ""),
      );

      // Force the map to re-render styles by retrieving and re-setting style
      const stylingFn = function (thisFeature) {
        let pathType = thisFeature.getProperty("pathType");
        let zoneType = thisFeature.getProperty("zoneType");
        const baseStyle = getStyleFromElementType(String(pathType ?? zoneType ?? ""));

        const featureId = String(thisFeature.getId() || "").replace(/[{}]/g, "");
        const isPartOfMission =
          missionPreviewActive &&
          missionPathUuids.some((uuid) => {
            return featureId === uuid;
          });

        if (
          selectedFeatureId &&
          thisFeature.getId &&
          String(thisFeature.getId()).replace(/[{}]/g, "") ===
            String(selectedFeatureId).replace(/[{}]/g, "")
        ) {
          // Normal mode: green highlight
          return {
            fillColor: "#289730",
            fillOpacity: 0.6,
            strokeColor: "#1C6521",
            strokeOpacity: 1,
            strokeWeight: 4,
            zIndex: 100,
          };
        }

        // Preview mode styling
        if (missionPreviewActive) {
          if (isPartOfMission) {
            // Grey outline for mission shapes
            return {
              ...baseStyle,
              strokeColor: "#888888",
              strokeOpacity: 0.6,
              strokeWeight: 3,
              fillOpacity: 0,
              zIndex: 50,
            };
          } else {
            // Fade non-mission elements with grey strokes
            return {
              ...baseStyle,
              strokeColor: "#999999",
              fillOpacity: (baseStyle.fillOpacity || 0.6) * 0.1,
              strokeOpacity: 0.2,
              zIndex: 1,
            };
          }
        }

        // Dim non-selected features when a feature is selected outside preview
        if (selectedFeatureId && !missionPreviewActive) {
          return {
            ...baseStyle,
            fillOpacity: (baseStyle.fillOpacity || 0.6) * 0.3,
            strokeOpacity: (baseStyle.strokeOpacity || 1) * 0.3,
            zIndex: 1,
          };
        }

        return baseStyle;
      } as google.maps.Data.StylingFunction;
      stylingFnRef.current = stylingFn;
      map.data.setStyle(stylingFn);
    }
  }, [missionPreviewActive, missionPreviewPaths, selectedFeatureId]);

  // Note: Load/Dump point markers are now handled in MissionPanel.tsx during animation
  // to allow dynamic label display based on vehicle proximity

  // if sessionName changes then clear the map

  return <></>;
}

// export async function animateVehicleRoute(route: any,vehicleType: string) {
//   const map = useMap('mainMap');
//   let thaisodfoasdf: google.maps.marker.AdvancedMarkerElementOptions = {
//     content: document.createElement('div')
//   }
//   let backgroundDiv = document.createElement('div');
//   // Create the Dumptruck component
//   const dumptruckIcon = document.createElement('div');
//   // const container = document.getElementById('app');
//   // const root = createRoot(container);
//   ReactDOM.render(<Dumptruck />, dumptruckIcon); // Render the Dumptruck component to the new div
//   // backgroundDiv.innerHTML = <></>
//   let startingLatLng: google.maps.LatLng = new google.maps.LatLng(route.points[0].location.latitude, route.points[0].location.longitude);
//   const thisMarker = new google.maps.marker.AdvancedMarkerElement({
//     position: startingLatLng,
//     content: backgroundDiv
//   })
//   if (map){
//     let theseOptions: google.maps.Data.FeatureOptions = {
//       id: "vehicleAnimation",
//       properties: thisMarker
//     };
//     let vehicleMarkerFeature = map.data.add(theseOptions);
//   }
// }

function LoggingButtons() {
  const map = useMap("mainMap");

  function logGEOJSON() {
    if (map) {
      map.data.toGeoJson((a: object) => {
        console.log(a);
      });
    }
  }

  return (
    <>
      <Button onClick={logGEOJSON}>Log This</Button>
    </>
  );
}

let tempPointList: any = [];
export function setTempPoints(mapPointList: any) {
  console.log("Updating the poinst");
  tempPointList = mapPointList;
}

/**
 * Compute an offset map center so the vehicle appears in the horizontal
 * middle of the area between the info-window's right edge and the screen's
 * right edge (CarPlay-style). Falls back to the raw position when the
 * viewport is too narrow for the offset to look good.
 */

// Module-level flag: set synchronously by the drag handler so the animation
// loop stops calling setCenter() before React re-renders with isFollowed=false.
let _followKilled = false;

function cabControlOffsetCenter(
  map: google.maps.Map,
  pos: google.maps.LatLngLiteral,
): google.maps.LatLngLiteral {
  const projection = map.getProjection();
  if (!projection) return pos;

  const mapDiv = map.getDiv();
  const mapWidth = mapDiv.offsetWidth;

  // Info window: 560px wide, 28px from left => right edge at 588px
  const infoRightEdge = 588;

  // Only offset if there's enough clear space (at least 400px to the right)
  if (mapWidth - infoRightEdge < 400) return pos;

  // We want the vehicle at the center of the clear area
  // clearCenter = infoRightEdge + (mapWidth - infoRightEdge) / 2
  // mapCenter   = mapWidth / 2
  // pixelShift  = mapCenter - clearCenter  (negative = shift map center left)
  const pixelShift = mapWidth / 2 - (infoRightEdge + (mapWidth - infoRightEdge) / 2);

  // Convert pixel shift to world-coordinate shift at current zoom
  const zoom = map.getZoom();
  if (zoom === undefined) return pos;
  const scale = Math.pow(2, zoom);

  const worldPoint = projection.fromLatLngToPoint(
    new google.maps.LatLng(pos.lat, pos.lng),
  );
  if (!worldPoint) return pos;

  // Pixel shift → world-coordinate shift
  worldPoint.x += pixelShift / scale;

  const offsetLatLng = projection.fromPointToLatLng(worldPoint);
  if (!offsetLatLng) return pos;

  return { lat: offsetLatLng.lat(), lng: offsetLatLng.lng() };
}

function InterpolatedVehicleMarker({
  position,
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className,
  isFollowed,
  isCabControl,
}: any) {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const map = useMap("mainMap");

  // Store the initial position to pass to the component, so React doesn't re-render/snap it on prop change
  const [initialPosition] = useState(position);

  // Track where the marker currently is visually
  const currentDiffRef = useRef<number>(0);
  const positionRef = useRef(position);

  // Track the previous target to calculate start point for cleaner interpolation
  const previousTargetRef = useRef(position);

  const animationFrameRef = useRef<number | null>(null);

  useEffect(() => {
    if (!marker) return;

    // Reset the kill flag on every effect run (deps include isFollowed,
    // so this clears it once React has caught up with the state change).
    _followKilled = false;

    // The new target is 'position' (prop)
    const targetPos = position;
    // The previous target was previousTargetRef.current
    // But we might be mid-animation. The marker.position is accurate *if* we've been updating it.

    // Get where the marker ACTUALLY is right now to start the animation from there.
    // This handles the case where we are mid-way through a previous animation.
    let startPos = positionRef.current;
    if (marker.position) {
      // AdvancedMarkerElement position can be LatLng or LatLngLiteral
      const mp = marker.position as any;
      if (mp.lat && typeof mp.lat === "function") {
        startPos = { lat: mp.lat(), lng: mp.lng() };
      } else if (mp.lat !== undefined) {
        startPos = mp;
      }
    }

    // Teleport if distance is too large (e.g. init or jump)
    const dist = Math.sqrt(
      Math.pow(targetPos.lat - startPos.lat, 2) + Math.pow(targetPos.lng - startPos.lng, 2),
    );
    if (dist > 0.05) {
      // ~5km degrees roughly
      marker.position = targetPos;
      positionRef.current = targetPos;
      previousTargetRef.current = targetPos;
      if (isFollowed && !_followKilled && map) {
        const center = isCabControl
          ? cabControlOffsetCenter(map, targetPos)
          : targetPos;
        map.setCenter(center);
      }
      return;
    }

    const startTime = performance.now();
    const duration = 1000; // 1 second interpolation (assuming 1Hz updates)

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Interpolate
      const lat = startPos.lat + (targetPos.lat - startPos.lat) * progress;
      const lng = startPos.lng + (targetPos.lng - startPos.lng) * progress;

      const newPos = { lat, lng };

      if (marker) {
        marker.position = newPos;

        if (isFollowed && !_followKilled && map) {
          const center = isCabControl
            ? cabControlOffsetCenter(map, newPos)
            : newPos;
          map.setCenter(center);
        }
      }
      positionRef.current = newPos;

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      }
    };

    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    animationFrameRef.current = requestAnimationFrame(animate);

    previousTargetRef.current = targetPos;

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [position, marker, isFollowed, isCabControl, map]);

  useEffect(() => {
    if (!marker) return;
    // The AdvancedMarkerElement positions its content element such that the
    // bottom-center aligns with the geo coordinate. We need the visual center
    // of the icon to align with the geo coordinate instead.
    const content = (marker as any).content as HTMLElement | null;
    if (content) {
      content.style.transform = "translateY(50%)";
    }
  }, [marker]);

  return (
    <AdvancedMarker
      ref={markerRef}
      // Vital: Only pass initial position.
      // If we pass 'position' prop, React will update the marker position
      // instantly on every prop change, fighting our animation.
      position={initialPosition}
      onClick={onClick}
      className={className}
    >
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {children}
      </div>
    </AdvancedMarker>
  );
}

function MapInterface({
  toggleCabControl,
  showCabControl,
  mapPointList,
  mapInstance,
  setMapInstance,
  mapGeometryList,
  gjson,
  mapEquipmentList,
  orgDataSession,
  sessionName,
  showGeometryOnMap,
  selectedFeatureId,
  setSelectedFeatureId,
  followedVehicleId,
  setFollowedVehicleId,
  missionPreviewActive,
  missionPreviewPaths,
  missionPreviewPoints,
}: {
  followedVehicleId?: string | null;
  setFollowedVehicleId?: (id: string | null) => void;
  toggleCabControl: (vehicleName?: string) => void;
  showCabControl: boolean;
  mapPointList: any[];
  mapInstance: google.maps.Map | null;
  setMapInstance: (map: any) => void;
  mapGeometryList: any;
  orgDataSession: any;
  gjson: any;
  mapEquipmentList: any[];
  sessionName: string;
  showGeometryOnMap: boolean;
  selectedFeatureId?: string | null;
  setSelectedFeatureId: (id: string | null) => void;
  missionPreviewActive: boolean;
  missionPreviewPaths: any[];
  missionPreviewPoints: any[];
}) {
  // John Deere Dubuque Coordinates
  let [currentLatLong, setLatLong] = useState({
    // 39.13616645353813, -99.38360808763339
    lat: 39.13616645353813,
    lng: -99.38360808763339,
  });
  const [mapObjectList, setMapObjectList] = useState([]);
  const [stateTempPointList, setStateTempPointList] = useState([]);
  const [hoveredVehicleIndex, setHoveredVehicleIndex] = useState<number | null>(null);
  const [hoveredVehicleLatLng, setHoveredVehicleLatLng] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [selectedFeatureInfo, setSelectedFeatureInfo] = useState<{
    name: string;
    type: string;
    latLng: { lat: number; lng: number };
  } | null>(null);
  const mapRef = useRef<HTMLDivElement>(null);
  const mapObj = useMap("mainMap");

  // Remember which vehicle is being cab-controlled so the re-center button can restore follow
  const cabControlVehicleRef = useRef<string | null>(null);
  useEffect(() => {
    if (showCabControl && followedVehicleId) {
      cabControlVehicleRef.current = followedVehicleId;
    }
    if (!showCabControl) {
      cabControlVehicleRef.current = null;
    }
  }, [showCabControl, followedVehicleId]);

  // Helper to get pixel position from lat/lng
  function getPixelPosition(lat: number, lng: number): { x: number; y: number } | null {
    const projection = mapObj.getProjection();
    const point = projection.fromLatLngToPoint(new window.google.maps.LatLng(lat, lng));
    const bounds = mapObj.getBounds();
    const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
    const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
    const zoom = typeof mapObj.getZoom === "function" ? mapObj.getZoom() : 0;
    const scale = Math.pow(2, zoom ?? 0);
    const x = (point.x - bottomLeft.x) * scale;
    const y = (point.y - topRight.y) * scale;
    return { x, y };
  }
  const map = useMap("mainMap");

  // store map instance
  useEffect(() => {
    if (setMapInstance && mapObj) {
      setMapInstance(mapObj);
    }
  }, [mapObj, setMapInstance]);

  // When user drags or zooms the map during cab control, stop following
  useEffect(() => {
    if (!mapObj || !showCabControl) return;
    const stopFollow = () => {
      if (followedVehicleId && setFollowedVehicleId) {
        _followKilled = true; // Immediate — stops animation centering before React re-renders
        setFollowedVehicleId(null);
      }
    };
    const dragListener = mapObj.addListener("dragstart", stopFollow);
    const zoomListener = mapObj.addListener("zoom_changed", stopFollow);
    return () => {
      google.maps.event.removeListener(dragListener);
      google.maps.event.removeListener(zoomListener);
    };
  }, [mapObj, showCabControl, followedVehicleId, setFollowedVehicleId]);

  useEffect(() => {
    setStateTempPointList(tempPointList);
  }, [tempPointList]);

  function flyToWhiteHouse() {
    setLatLong({ lat: 62.2176, lng: -148.8997 });
  }

  const divStyle: CSSProperties | undefined =
    showCabControl || false
      ? {
          position: "fixed",
          inset: 0,
          top: "0px",
          left: "0px",
          width: "100dvw",
          // height: 'calc(100dvh - 100px)',
          height: "100dvh",
          zIndex: 1100,
        }
      : undefined; // No inline style if showCabControl is false

  return (
    <div
      className={`MapInterface${showCabControl ? " MapInterface--cabControl" : ""}`}
      style={divStyle}
      ref={mapRef}
    >
      {(showCabControl || false) && (
        <div className="CabControlClose">
          <IconCircleClose size={40} onClick={toggleCabControl} />
        </div>
      )}

      {/* <APIProvider apiKey={'AIzaSyBGE3dEEemmnwal41oxhnphiaoYy3s-P2c'} libraries={["drawing"]}> */}
      <Map
        id={"mainMap"}
        mapId={"mainMap"}
        mapTypeId={"hybrid"}
        disableDefaultUI={true}
        defaultCenter={currentLatLong}
        defaultZoom={4}
        maxZoom={25}
      >
        {/* <LoggingButtons /> */}
        {/* Draw markers for each item in mapItemsList */}
        {!missionPreviewActive &&
          mapEquipmentList.map((item, index) => {
            const {
              position,
              referenceDiv,
              callback,
              name,
              type,
              model,
              isMachineActive,
              vehicleName,
            } = item;
            return (
              <InterpolatedVehicleMarker
                key={vehicleName || index}
                position={position}
                isFollowed={followedVehicleId && vehicleName === followedVehicleId}
                isCabControl={showCabControl}
                onClick={() => {
                  callback();
                  if (showCabControl && setFollowedVehicleId && vehicleName) {
                    cabControlVehicleRef.current = vehicleName;
                    setFollowedVehicleId(vehicleName);
                  }
                }}
                onMouseEnter={() => {
                  setHoveredVehicleIndex(index);
                  setHoveredVehicleLatLng(position);
                }}
                onMouseLeave={() => {
                  setHoveredVehicleIndex(null);
                  setHoveredVehicleLatLng(null);
                }}
                className="" // InterpolatedVehicleMarker doesn't use className effectively on AdvancedMarker for internal div styling, but handles children.
              >
                <div
                  className={
                    (isMachineActive
                      ? "map-equipment-marker map-equipment-marker--active"
                      : "map-equipment-marker map-equipment-marker--inactive") +
                    (showCabControl && cabControlVehicleRef.current && vehicleName === cabControlVehicleRef.current
                      ? " map-equipment-marker--cab-selected"
                      : "")
                  }
                  style={selectedFeatureId ? { opacity: 0.3 } : undefined}
                >
                  {referenceDiv}
                </div>
              </InterpolatedVehicleMarker>
            );
          })}
        {!missionPreviewActive &&
          mapPointList.map((item, index) => {
            const { position, referenceDiv, callback } = item; // Destructure the item
            // console.log(position);

            return (
              <AdvancedMarker
                key={index} // Use index as key or a unique identifier if available
                position={position}
                onClick={callback} // Call the callback function when the marker is clicked
              >
                <div>{referenceDiv}</div>
              </AdvancedMarker>
            );
          })}
        {!missionPreviewActive &&
          stateTempPointList.map((item, index) => {
            const { position, referenceDiv, callback } = item; // Destructure the item
            // console.log(position);

            return (
              <AdvancedMarker
                key={index} // Use index as key or a unique identifier if available
                position={position}
                onClick={callback} // Call the callback function when the marker is clicked
              >
                <div>{referenceDiv}</div>
              </AdvancedMarker>
            );
          })}

        {/* <Marker position={currentLatLong} /> */}
        {/* <GeoJSONDisplay gjson={gjson} /> */}
        <MapObjectDisplay
          mapInstance={mapInstance}
          setMapInstance={setMapInstance}
          sessionName={sessionName}
          mapGeometryList={mapGeometryList}
          mapEquipmentList={mapEquipmentList}
          orgDataSession={orgDataSession}
          selectedFeatureId={selectedFeatureId}
          setSelectedFeatureId={setSelectedFeatureId}
          missionPreviewActive={missionPreviewActive}
          missionPreviewPaths={missionPreviewPaths}
          missionPreviewPoints={missionPreviewPoints}
          onFeatureClick={setSelectedFeatureInfo}
          showCabControl={showCabControl}
        />
      </Map>
      {/* Custom floating tooltip for hovered vehicle */}
      {!missionPreviewActive &&
        hoveredVehicleIndex !== null &&
        hoveredVehicleLatLng &&
        (() => {
          const pixel = getPixelPosition(hoveredVehicleLatLng.lat, hoveredVehicleLatLng.lng);
          if (!pixel || !mapRef.current) return null;
          const vehicle = mapEquipmentList[hoveredVehicleIndex];
          const tooltipWidth = 120; // Approximate width of the tooltip in px
          const tooltipHeight = 48; // Approximate height of the tooltip in px
          const extraOffset = 64; // Increased space above the icon (was 48)
          const mapRect = mapRef.current.getBoundingClientRect();
          // Use position: fixed and add mapRect offsets
          const left = mapRect.left + pixel.x - tooltipWidth / 2;
          const top = mapRect.top + pixel.y - tooltipHeight - extraOffset;
          return (
            <div
              className="vehicle-pointer-div map-tooltip"
              style={{
                position: "fixed",
                left: left,
                top: top,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "8px",
                width: tooltipWidth,
                zIndex: 2000,
                pointerEvents: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              <div>
                <strong>Name:</strong> {vehicle?.vehicleName ?? "N/A"}
              </div>
              <div>
                <strong>Type:</strong> {vehicle?.vehicleType ?? "N/A"}
              </div>
              <div>
                <strong>Model:</strong> {vehicle?.vehicleModel ?? "N/A"}
              </div>
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  bottom: "-10px",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "8px solid transparent",
                  borderRight: "8px solid transparent",
                  borderTop: "10px solid #fff",
                  zIndex: 2001,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  bottom: "-12px",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "9px solid transparent",
                  borderRight: "9px solid transparent",
                  borderTop: "12px solid #ccc",
                  zIndex: 2000,
                }}
              />
            </div>
          );
        })()}
      {/* Custom floating tooltip for selected attribute */}
      {!missionPreviewActive &&
        selectedFeatureInfo &&
        (() => {
          const pixel = getPixelPosition(
            selectedFeatureInfo.latLng.lat,
            selectedFeatureInfo.latLng.lng,
          );
          if (!pixel || !mapRef.current) return null;
          const tooltipWidth = 140;
          const tooltipHeight = 48;
          const extraOffset = 20;
          const mapRect = mapRef.current.getBoundingClientRect();
          const left = mapRect.left + pixel.x - tooltipWidth / 2;
          const top = mapRect.top + pixel.y - tooltipHeight - extraOffset;
          return (
            <div
              className="map-tooltip"
              style={{
                position: "fixed",
                left: left,
                top: top,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "8px",
                width: tooltipWidth,
                zIndex: 2000,
                pointerEvents: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              <div>
                <strong>Name:</strong> {selectedFeatureInfo.name}
              </div>
              <div>
                <strong>Type:</strong> {selectedFeatureInfo.type}
              </div>
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  bottom: "-10px",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "8px solid transparent",
                  borderRight: "8px solid transparent",
                  borderTop: "10px solid #fff",
                  zIndex: 2001,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  bottom: "-12px",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "9px solid transparent",
                  borderRight: "9px solid transparent",
                  borderTop: "12px solid #ccc",
                  zIndex: 2000,
                }}
              />
            </div>
          );
        })()}
      {/* Cab Control: Re-center / follow button — visible when follow is off */}
      {showCabControl && !followedVehicleId && cabControlVehicleRef.current && (
        <button
          className="CabHUD-RecenterBtn"
          onClick={() => {
            if (setFollowedVehicleId && cabControlVehicleRef.current) {
              setFollowedVehicleId(cabControlVehicleRef.current);
            }
          }}
          aria-label="Re-center on vehicle"
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="4" />
            <line x1="12" y1="2" x2="12" y2="6" />
            <line x1="12" y1="18" x2="12" y2="22" />
            <line x1="2" y1="12" x2="6" y2="12" />
            <line x1="18" y1="12" x2="22" y2="12" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default MapInterface;

/*
  To highlight a feature, pass its ID as selectedFeatureId to MapInterface from the parent component.
  Example: <MapInterface selectedFeatureId={selectedId} ... />
  The selectedId should be set when a feature is selected in the properties panel.
*/
